import { render } from "./GridKPIEchipa.vue?vue&type=template&id=33c12be8&scoped=true&ts=true"
import script from "./GridKPIEchipa.vue?vue&type=script&lang=ts"
export * from "./GridKPIEchipa.vue?vue&type=script&lang=ts"

import "./GridKPIEchipa.vue?vue&type=style&index=0&id=33c12be8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c12be8"]])

export default __exports__